import { format, formatDistanceStrict } from 'date-fns'
import Flickity from 'react-flickity-component'
import React from "react";
import { graphql } from "gatsby";
import toHTML from "../helpers/toHtml";
import Helmet from "react-helmet";
import Img from "gatsby-image";
import styled from "styled-components";
import Layout from "../components/Layout";
import colors from "../styles/colors";

const ImageSliderImage = styled(Img)`
  scroll-snap-align: center;
  flex-shrink: 0;
  width: 60rem;
  min-height: 100%;
  max-height: 80vh;
  margin-right: 0.5rem;
  position: relative;
`;

const Wrapper = styled.section`
  max-width: 90%;
  width: 100rem;
  margin: ${p => (p.inline ? "5rem" : "0")} auto;
  background: ${colors.white};
  border-radius: ${p => (p.inline ? "0.5rem" : "0")};
  overflow: visible;
  overflow-x: hidden;
  position: relative;
  transition: all 0.3s ease;
  opacity: ${p => (p.animate === "enter" ? "1" : "0")};
  transform: scale(${p => (p.animate === "enter" ? "1" : ".9")});
`;

const Text = styled.div`
  padding: 3rem;
  max-width: 50rem;
  margin: 0 auto;
`;

const Preamble = styled.p`
  font-size: 1.2rem;
`;

const DateText = styled.p`
  font-size: 1.2rem;
  font-weight: lighter;
  margin-top: -1.7rem;
`;

const Bold = styled.b`
  font-weight: bold;
`

export const CaseTemplate = ({
  study,
  helmet,
  inline = false,
  animate
}) => {
  study.startDate = new Date(study.startDate);
  study.endDate = study.endDate ? new Date(study.endDate) : false;
  return (
    <Wrapper inline={inline} animate={animate}>
      {helmet || ""}

      <Flickity
        className={'carousel'} // default ''
        elementType={'div'} // default 'div'
        options={{}} // takes flickity options {}
        disableImagesLoaded={false} // default false
        reloadOnUpdate // default false
        static // default false
      >
        {study.galleryImages &&
          study.galleryImages.length &&
          study.galleryImages.map(
            (image, index) =>
              image &&
              (image.childImageSharp ? (
                <ImageSliderImage
                  className="img"
                  key={image.childImageSharp.fluid.src}
                  fluid={image.childImageSharp.fluid}
                  alt={study.title}
                />
              ) : (
                <ImageSliderImage
                  as="img"
                  src={image}
                  alt={study.title} />
              ))
          )}
      </Flickity>

      <Text>
        <h1>{study.title}</h1>
        {study.startDate && study.endDate &&
          <DateText><Bold>{formatDistanceStrict(study.endDate, study.startDate, { unit: 'month' })}</Bold> | {format(study.startDate, 'dd/MM/yyyy')} - {format(study.endDate, 'dd/MM/yyyy')}</DateText>
        }
        {study.startDate && !study.endDate &&
          <DateText><Bold>Pågående</Bold> | {format(study.startDate, 'dd/MM/yyyy')} - </DateText>
        }
        <Preamble>{study.preamble}</Preamble>
        <div dangerouslySetInnerHTML={{ __html: toHTML(study.description) }} />
      </Text>
    </Wrapper>
  );
};

const Case = ({ data, study, animate = "enter", inline = false }) => {
  study = data ? data.markdownRemark : study;
  console.log(data, study);
  return (
    <Layout>
      <CaseTemplate
        study={study.frontmatter}
        animate={animate}
        inline={inline}
        helmet={
          <Helmet titleTemplate="%s | Torslanda Entrepenad">
            <title>{`${study.frontmatter.title}`}</title>
            <meta
              name="description"
              content={`${study.frontmatter.description}`}
            />
          </Helmet>
        }
      />
    </Layout>
  );
};

export default Case;

export const pageQuery = graphql`
  query CaseByID($id: String!) {
    markdownRemark(id: { eq: $id }){
      id
      html
      frontmatter {
        title
        startDate
        endDate
        description
        preamble
        galleryImages {
          childImageSharp {
            fluid(maxWidth: 700, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;